import { JSX } from "react";
import { Navigate } from "react-router-dom";
import Footer from "../footer";
import Header from "../header";
import { useAuth } from "react-oidc-context";
import './Layout.css';

function RequireAuth({ children }: { children: JSX.Element }) {
    const auth = useAuth();
    return !auth.isAuthenticated ? <Navigate to="/login" replace /> : children;
}

type Props = {
    children?: React.ReactNode;
    onShowTutorial?: () => void;
    isWebSocketConnected?: boolean;
    hostVersion?: string;
};

export function Layout({ children, onShowTutorial, isWebSocketConnected, hostVersion }: Props) {
    return (
        <RequireAuth>
            <div className="layout">
                <Header onShowTutorial={onShowTutorial} isWebSocketConnected={isWebSocketConnected} hostVersion={hostVersion} />
                {children}
                <Footer />
            </div>
        </RequireAuth>
    );
}